import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class InsurancePlanDA {
  static apiResponse: ApiResponse

  public static async getPlans(
    id_company: string,
    query?: { type?: string; active?: string }
  ): Promise<ApiResponse> {
    const params = new URLSearchParams()
    if (query?.type) params.set('type', query.type)
    if (query?.active) params.set('active', query.active)
    const qs = params.toString()
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/insurance-plans${qs ? `?${qs}` : ''}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getPlan(
    id_company: string,
    id_plan: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/insurance-plans/${id_plan}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async createPlan(
    id_company: string,
    body: any
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/insurance-plans`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async updatePlan(
    id_company: string,
    id_plan: string,
    body: any
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/insurance-plans/${id_plan}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async deletePlan(
    id_company: string,
    id_plan: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/insurance-plans/${id_plan}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
